import { GetProductsByIdBatchedQuery } from '@notino/shared/definitions/types';

export const findNullProductIds = (
  requestIds: string[],
  nonNullProducts: GetProductsByIdBatchedQuery['vpProductByIds']
) => {
  const nonNullProductIds = nonNullProducts.map((x) => x.id);
  return requestIds.filter((id) => !nonNullProductIds.includes(id));
};
